<!--
 * @Author: Gaho
 * @Date: 2024-01-12 13:35:50
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-08 14:59:47
 * @Description: 目前仅用于 Waves 游戏 
-->

<template>
    <!-- ↓ 押注（币种图标） -->
    <CasinoHistoryBodyCell
        class="flex-[0.3]"
    >
        <span class="flex flex-nowrap cursor-pointer" 
            @click="jump2TargetCoin(history.pairCurrency)"
        >
            <CurrentCoin
                class="w-[20px]"
                :name="history.pairCurrency"
            ></CurrentCoin>
            <IconSvgUse
                class="shrink-0"
                size="20px"
                :use="history.oTypeColor?.icon02"
                :style="{color: history.oTypeColor?.color }"
            />
        </span>
    </CasinoHistoryBodyCell>
    <!-- ↓ 总押注 -->
    <!-- <CasinoHistoryBodyCell
        class="flex-[0.4]"
    >
        <span class="word-warp flex flex-nowrap items-center"> 
            <CurrentCoin
                size="16px"
                class="mr-1"
                :name="history.currency"
            ></CurrentCoin>
            <span>
                <em class="wave-amount">
                    <WavesValue
                        :number-value="history.wager"
                        :iTailLong="history.iDecimalPlaces"
                        :coinName="history.currency" 
                    ></WavesValue>
                </em>
                <Popper
                    :style="oPopperStyle"
                    :hover="true"
                    :arrow="true"
                    placement="top"
                    :offsetDistance="'5px'" 
                >
                    <small class="wave-leverage " style="color: var(--Background-Secondary)"> 
                        x{{ history.multi }} 
                    </small>
                    <template #content>
                        <div class="popper-content" style="color: var(--Background-Secondary)"> 
                            {{ $t('waves.Multiplier') }} 
                        </div>
                    </template>
                </Popper>
            </span>
        </span>
    </CasinoHistoryBodyCell> -->
    <!-- ↓ 入场价格 -->
    <!-- <CasinoHistoryBodyCell
        class="flex-[0.5]"
    >
        <span class="word-warp">
            <WavesValue
                :number-value="history.entryPrice"
                :iTailLong="history.precision"
            ></WavesValue>
        </span>
    </CasinoHistoryBodyCell> -->
    <!-- ↓ 爆仓价格，  -->
    <!-- <CasinoHistoryBodyCell
        class="flex-[0.5]"
    >
        <span class="word-warp">
            <WavesValue
                :number-value="history.bustPrice"
                :iTailLong="history.precision"
            ></WavesValue>
        </span>
    </CasinoHistoryBodyCell> -->
    <!-- ↓ 资金费率／每小时 -->
    <!-- <CasinoHistoryBodyCell 
        class="flex-[0.4]"
    >
        <span class="word-warp"
            :style="{ color: oFundingStatus.color }"
        >
            <WavesValue
                :number-value="oFundingStatus.value" 
                :iTailLong="4"
            ></WavesValue>
        </span>
    </CasinoHistoryBodyCell> -->
    <!-- ↓ P&L, ROI --> 
    <CasinoHistoryBodyCell
        class="flex-[0.5]" 
    >
        <span class="flex flex-nowrap w-full items-center space-between cursor-pointer"> 
            <span class="word-warp" > 
                <em class="wave-amount"
                    :style="{ color: oActiveColors.pnl.color }"
                >
                    <WavesValue
                        :offsetDistance="'5px'"
                        :number-value="oPNLnROI.pnl"
                        :iTailLong="history.iDecimalPlaces"
                        :coinName="history.currency" 
                    ></WavesValue>
                </em>
                <small class="wave-leverage text-inherit"
                    :style="{ color: oActiveColors.roi.colorShallow }" 
                >
                    <WavesValue
                        :suffix="'%'"
                        :offsetDistance="'5px'"
                        :number-value="oPNLnROI.roi"
                    >
                        <span style="color: var(--Background-Secondary)" >
                            ROI
                        </span>
                    </WavesValue>
                </small>
            </span>
        </span>
    </CasinoHistoryBodyCell>
    <!--
        ↓ 最后一列，操作列 =============================================== 
    -->
    <CasinoHistoryBodyCell
        class="flex-[0.7] pr-1" 
    >
        <span class="flex flex-nowrap items-center w-full"> 
            <!-- ↓ 当前状态会逗留一两秒，然后被新的数据顶替而消失 -->
            <ContractState
                v-if="iStateStep == 2" 
                :state="sRealtimeState" 
            ></ContractState>
            <!--
                ↑ 已经平仓
                ↓ 尚未平仓，有效合约（默认状态） 
            -->
            <template v-else>
                <ButtonThe3DButton
                    color="red"
                    size="sm"
                    class="cash-out-btn"
                    @click="toCashOneOut" 
                    style="min-width: 50px"
                    v-click-and-rest 
                    :disabled="iStateStep > 0"
                    :dismark="iStateStep > 0"
                >
                    <!-- ↓ 平仓执行期间显示 Loading 动画 --> 
                    <template v-if="iStateStep == 1">
                        {{ locale == 'en' ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '' }}
                        <IconSvgUse
                            size="16px"
                            use="icon-loading"
                            class="animate-spin"
                        />
                        {{ locale == 'en' ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '' }}
                    </template>
                    <template v-else>
                        {{ $t('waves.CashOut') }}
                    </template>
                </ButtonThe3DButton>
                <!-- ↑ 提现按钮 -->
                <!-- ↓ 设定止盈止损金额 -->
            <ClientOnly>
                <Popper 
                    :style="oPopperStyle"
                    :hover="true"
                    :arrow="true"
                    :disabled="isMobileDevice"
                    placement="top"
                >
                    <ButtonGrayButton
                        @click="openPnlSetting"
                        class="mx-3 w-[28px] h-[28px] cursor-pointer"
                        style="padding: 0"
                        v-click-and-rest 
                        :disabled="iStateStep > 0"
                        :dismark="iStateStep > 0"
                    >
                        <IconSvgUse
                            size="15px"
                            :use="sBtnIconName"
                            class="inline-block"
                        />
                    </ButtonGrayButton>
                    <template #content>
                        <div class="popper-content"> 
                            <span v-if="!sTriggerMark">
                                {{ $t('waves.tipsOnWinLose') }} 
                            </span>
                            <template v-else>
                                <p class="item" v-if="sTriggerMark.includes('A')">
                                    <span class="title">
                                        {{ $t('waves.tipsOnWin') }} 
                                    </span>
                                    <em class="text-white" v-if="history.takeProfitPrice">
                                        {{ $t('waves.Price') }}
                                        {{ number2LocaleString(history.takeProfitPrice, history.precision) }}
                                    </em>
                                    <em :style="{color: oColorInfo.green.color }" v-if="history.takeProfitAmount">
                                        (+{{
                                            Number(history.takeProfitAmount).toFixed(history.iDecimalPlaces)
                                            + ' ' + $t('waves.Profit')
                                        }})
                                    </em>
                                </p>
                                <!-- ↑止盈，↓止损 -->
                                <p class="item" v-if="sTriggerMark.includes('B')">
                                    <span class="title">
                                        {{ $t('waves.tipsOnLose') }}
                                    </span>
                                    <em class="text-white" v-if="history.stopLossPrice">
                                        {{ $t('waves.Price') }} 
                                        {{ number2LocaleString(history.stopLossPrice, history.precision) }}
                                    </em>
                                    <em :style="{color: oColorInfo.red.color }" v-if="history.stopLossAmount"> 
                                        (-{{
                                            Number(history.stopLossAmount).toFixed(history.iDecimalPlaces)
                                            + ' ' + $t('waves.Loss') 
                                        }})
                                    </em>
                                </p>
                            </template>
                        </div>
                    </template>
                </Popper>
            </ClientOnly>
            </template>
            <span class="ml-auto"/>
            <!-- ↓打开详情窗口 -->
        <ClientOnly>
            <Popper
                :style="oPopperStyle"
                :hover="true"
                :arrow="true"
                :disabled="isMobileDevice" 
                placement="top"
            >   
                <button
                    class="block cursor-pointer w-[22px]"
                    v-click-and-rest 
                    :disabled="iStateStep > 0"
                    :dismark="iStateStep > 0"
                    @click="openDetailModal"
                >
                    <IconSvgUse
                        size="22px"
                        :use="'icon-info-circle-2'"
                    />
                </button>
                <template #content>
                    <div class="popper-content"> 
                        {{ $t('waves.BetDetails') }} 
                    </div>
                </template>
            </Popper>
        </ClientOnly>
            &nbsp;
        </span>
    </CasinoHistoryBodyCell>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";
import ContractState from "@/pages/casino/futuresGame/_components/contractState.vue"; 
import WavesValue from '@/pages/casino/futuresGame/_components/wavesValue.vue'; 
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
// -- ↑ 组件 ------------------------------------- 
import type { WavesHistoryPlus } from '@/socket/game/dto/waves.dto';
import { 
    fnSettingCenter_Ft, 
    oPositionData_i, 
    settingsState_f, 
    oPositionCenter_yt, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 
import { 
    oColorInfo,
    oWavesContractStatus,
    WavesContractStateAll,
} from '@/pages/casino/futuresGame/ts/wavesData'; 
import { 
    getActiveContractInfo, 
    jump2TargetCoin, 
} from '@/pages/casino/futuresGame/ts/wavesFn'; 


const {t: $tFn, locale} = useNuxtApp().$i18n;
const emit = defineEmits(['dialogControl','openGameDetail']);
const isMobileDevice = import.meta.client && ('ontouchstart' in window);
const props = defineProps({
    isMobileMode: {
        type: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    },
    history: {
        type: Object as PropType<WavesHistoryPlus>, 
        default: () => ({}),
    },
    tabName: {
        type: String as PropType<HistoryTabsEnum>, 
    },
});

// ↓ 窗口可见性管理 --- 
const oMyPositionCenter = oPositionCenter_yt();
const oSettingCenter = fnSettingCenter_Ft(); 

// ↓ 当前合约实时的“最新” 状态 
const sRealtimeState = computed(() => {
    const oLib = oPositionData_i.beforeRemovalInfo || {};
    const oTarget = oLib[props.history._id];
    // 返回值是 oTarget?.state 的具体形态请参考：WavesContractStateAll 
    return oTarget?.state;
});

// ↓ 广义的关闭（关闭中，爆仓，止损等都算关闭） 
// const isBroadlyClosed = computed(()=>{
//     const bResult = (
//         !!sRealtimeState.value
//         && sRealtimeState.value != WavesContractStateAll.active 
//     );
//     return bResult; 
// });

// ↓ 广义的关闭（关闭中，爆仓，止损等都算关闭） 
const iStateStep = computed(()=>{
    if (!sRealtimeState.value) {
        return 0;
    }
    if (sRealtimeState.value == WavesContractStateAll.cashOutProcessing){
        return 1;
    }
    if (sRealtimeState.value != WavesContractStateAll.active){
        return 2; // profit, loss, busted, cashed, 广义关闭
    }
    return 0; 
});


const oFundingStatus = computed(()=>{
    const funding = props.history.funding;
    const oResult = {
        value: funding || null,
        color: (()=>{
            if (funding > 0){
                return oColorInfo.green.color; 
            }else if (funding < 0){
                return oColorInfo.red.color; 
            }
        })(),
    };
    return oResult;
});

// ↓ 取得合约的动态数据 
const oActiveContractInfo = computed(()=>{
    return getActiveContractInfo(props.history); 
});

// ↓ 最终 PNL + ROI 值，
const oPNLnROI = computed(() => {
    // ↓ 特定状态（已关闭的合约）下不显示数值 
    const noColor = iStateStep.value > 0; 
    return {
        pnl: noColor ? null : oActiveContractInfo.value.pnl,
        roi: noColor ? null : oActiveContractInfo.value.roi,
    }
});

// ↓ 最终 PNL + ROI 值对应的颜色 
const oActiveColors = computed(()=>{
    const oResult = {
        pnl: (
            oPNLnROI.value.pnl > 0
            ? oColorInfo.green
            : oColorInfo.red
        ),
        roi: (
            oPNLnROI.value.roi > 0
            ? oColorInfo.green
            : oColorInfo.red
        ),
    };
    return oResult; 
});

// ↓ 触发设定状态标记 
const sTriggerMark = computed(() => {
    const his = props.history;
    let sResult = '';
    if (his.takeProfitPrice || his.takeProfitAmount){
        sResult += 'A';
    }
    if (his.stopLossPrice || his.stopLossAmount){
        sResult += 'B';
    }
    return sResult; 
});

// ↓ 图标名 
const sBtnIconName = computed(() => {
    let sResult = "waves-set-btn";
    if (sTriggerMark.value == 'AB'){
        sResult = "waves-set-btn-stop-win-lose"; 
    }else if (sTriggerMark.value == 'A'){
        sResult = "waves-set-btn-stop-win"; 
    }else if (sTriggerMark.value == 'B'){
        sResult = "waves-set-btn-stop-lose";
    }
    // console.log("图标 =", his._id, sResult); 
    return sResult; 
});


// ↓ 最后执行平仓
// ↓ 在确认窗口中点击【确定】按钮时也有调用此方法 
const toCashOneOut = () => {
    // ↓ 不需要弹出确认窗口，在此直接关闭合约 
    if (!settingsState_f.userSettings.confirmCashOut){
        console.log("平仓目标：", deepCopy(props.history)); 
        oMyPositionCenter.closePositionById({
            positionId: props.history._id,
        });
        return;
    }
    // ↓ 调用父级组件弹出确认窗口，
    const closeConfirm = {
        visible: true,
        all: false,
    };
    emit('dialogControl', {closeConfirm});
};

// ↓ 打开“详情” 窗口 
const openDetailModal = () => {
    //  ↓ 游戏详情传值
    const data = {
        data: `futures:${props.history._id}`,
        modal: 'BetDetails',
        wavesType: HistoryTabsEnum.active,
    }
    emit('openGameDetail',data)
    
    // ↓ 打开游戏详情，取消跳转事件，改为直接打开游戏详情浮层
    // const {path, query={}} = useRoute();
    // useRouter().push({
    //     replace: true, 
    //     path,
    //     query: {
    //         ...query,
    //         data: `futures:${props.history._id}`,
    //         modal: 'BetDetails',
    //         wavesType: HistoryTabsEnum.active,
    //     },
    // });
};

// ↓ 打开止赢止损设置窗口 
const openPnlSetting = () => {
    const pnlSetting = {
        visible: true,
    };
    emit('dialogControl', { pnlSetting });
};

</script>

<style scoped lang="scss" src="./style/wavesTable.scss"></style>
<style scoped lang="scss">
.word-warp{
    color: white;
    font-size: 12px;
    font-weight: 600;
    // letter-spacing: -.5px;
    width: 100%; 
    cursor: default;
}

.wave-amount{
    display: block;
    margin: auto 0;
    line-height: 14px;
    overflow-x: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.wave-leverage{
    display: block;
    font-size: 11px;
    line-height: 14px;
}

.popper-content{
    font-size: 12px; 
    line-height: 18px;
    font-weight: normal; 
    em{
        font-weight: bold; 
    }
    .title{
        display: block;
    }
}

.cash-out-btn :deep(){
    .row-01 span{
        white-space: nowrap;
        display: flex;
    }
}

</style>

